import { isEqual } from 'lodash';

export const fixZaloJSV2Error = () => {
  if (!isEqual(typeof window, 'undefined')) {
    (window as any).zaloJSV2 = {
      zalo_h5_event_handler: () => {},
    };
  }
};
